import './App.css';
import './assets/css/business-profitable.css'
import BusniessProfitable from './page/business-profitable';

function App() {
  return (
    <div className="App">
      <BusniessProfitable />
    </div>
  );
}

export default App;
